import type { ModuleLoaderFactory } from '@wix/thunderbolt-renderer-utils'
import { createReactModuleCode } from './reactTemplate'

const createImportMap = (dependencies: Record<string, any>) => {
	if (typeof window === 'undefined') {
		return
	}
	const importMap: Record<string, string> = {}

	Object.entries(dependencies).forEach(([name, value]) => {
		if (name === 'react') {
			const code = createReactModuleCode(name, value)
			const blob = new Blob([code], { type: 'text/javascript' })
			importMap[name] = URL.createObjectURL(blob)
		} else {
			// By default the value is a url
			importMap[name] = value
		}
	})

	const mapScript = document.createElement('script')
	mapScript.type = 'importmap'
	mapScript.textContent = JSON.stringify({ imports: importMap })
	document.head.appendChild(mapScript)
}

export const esmLoaderFactory: ModuleLoaderFactory = ({ scriptsCache, defaultDependencies = {} }) => {
	if (Object.keys(defaultDependencies).length > 0) {
		createImportMap(defaultDependencies)
	}
	return {
		prefetchScript: (_url) => {
			// not implemented for esm
		},
		loadModule: async (url) => {
			const cached = scriptsCache[url]
			if (cached) {
				return cached
			}

			try {
				const module = await import(/* webpackIgnore: true */ url)
				scriptsCache[url] = module
				return module
			} catch (error) {
				delete scriptsCache[url]
				throw error
			}
		},
	}
}
